export default __webpack_public_path__ + "static/media/corn.30309a7c.png";